const destinations = [
  {
    name: "United Kingdom",
    context: "Thomson Reuters London hub, business meetings, and direct MSP connections",
    urgency: "Corporate travel often has 10–21 day lead time from Eagan",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Ireland",
    context: "Healthcare conferences, Blue Cross Blue Shield industry events, Dublin direct flights",
    urgency: "Conference schedules are fixed and non-negotiable",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean",
    context: "Family cruises, Cancun resort vacations, and spring break from MSP",
    urgency: "Last-minute cruise deals and resort packages compress booking timelines",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Germany",
    context: "Frankfurt business connections, Munich trade shows, technology partnerships",
    urgency: "Tech and financial trade shows have fixed dates and non-refundable registration fees",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Toronto business, Ontario fishing trips, and summer cabin visits",
    urgency: "Summer travel peak runs May through September",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Japan & Singapore",
    context: "Technology partnerships, corporate assignments, and Asia business travel",
    urgency: "Asia business trips frequently have 10–21 day booking windows",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "~5 Miles",
    label: "Eagan to MSP Airport — one of the closest suburbs to Minnesota's primary international gateway",
  },
  {
    stat: "65%",
    label: "of Eagan expedited requests are business travelers with under 3 weeks until departure",
  },
  {
    stat: "2–3 Weeks",
    label: "typical corporate travel notice period Eagan business travelers receive before international assignments",
  },
  {
    stat: "24 Hours",
    label: "fastest emergency turnaround for an Eagan business traveler with a same-week MSP departure",
  },
];

export default function EaganDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Eagan Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Eagan clients. Understanding local travel behavior is part of why our document review catches issues before they derail your business trip, conference, or family vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Minnesota Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Minnesota with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/minneapolis" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Minneapolis <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/st-paul" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                St. Paul <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/bloomington" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Bloomington <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}